/**
 * Performance Tracker Module
 *
 * Barrel export + global singleton.
 * Justified: 5+ consumers (stream.ts, marketStream.ts, useOrderManagement,
 * diagnostics checks, usePerfTracker hook).
 */

export type {
  PerfCategory,
  PerfSpan,
  SpanToken,
  PerfGauge,
  PerfStats,
  PerfSnapshot,
} from './types';

export { PerfTracker } from './tracker';

import { PerfTracker } from './tracker';

export const perfTracker = new PerfTracker();
